import React from 'react'

import Notification from '../Notification'
import moment from 'moment'

const dateNotification = ({ date, notifications }) => (
    <React.Fragment>
        <div className="container border-bottom">
            <h6 className="pt-4 text-muted">
                {
                    (date === moment(Date.now()).format('D MMMM YYYY'))
                        ? 'Today'
                        : date
                }
            </h6>
        </div>
        {
            notifications.map(notification => (
                <Notification 
                    key={notification.id} 
                    notification={notification} />
            ))
        }
    </React.Fragment>
)

export default dateNotification